module.exports = __webpack_public_path__ + "assets/44f1bb201c9508ab48790c136b711f37.mp3";